import { jsx as _jsx } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import './Component_JSONPreview.scss';
import { deepClone } from '@nu-art/ts-common';
import { QJSONViewer } from '../../../../../../q-components/index.js';
export class Component_JSONPreview extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        return super.deriveStateFromProps(nextProps, state);
    }
    render() {
        const editableClone = deepClone(this.state.editable.item);
        return _jsx(LL_V_L, { className: 'json-view', children: _jsx(QJSONViewer, { filterGenerated: true, item: editableClone }) });
    }
}
//# sourceMappingURL=Component_JSONPreview.js.map